import { ViewColumnField } from "./view-column-field.model";
import { ViewColumnGroup } from "./view-column-group.model";
import { ViewCondition } from "./view-condition.model";
import { ViewConfig } from "./view-config.model";
import { ViewFilterField } from "./view-filter-field.model";
import { ViewFormField } from "./view-form-field.model";
import { ViewFormula } from "./view-formula.model";
import { ViewSettings } from "./view-settings.model";

export class TableViewConfig extends ViewConfig {
    filter_sql: string;
    count_sql: string;
    search_sql: string;
    get_sql: string;
    new_sql: string;
    view_fields: ViewFormField[];
    column_fields: ViewColumnField[];
    filter_fields: ViewFilterField[];
    column_groups: ViewColumnGroup[];
    view_conditions: ViewCondition[];
    view_formulas: ViewFormula[];
    view_settings: ViewSettings;
    default_filters: any;
}

export class DashboardViewConfig extends ViewConfig {
    filter_sql: string;
    search_sql: string;
    filter_fields: ViewFilterField[];
    view_conditions: ViewCondition[];
    view_formulas: ViewFormula[];
    view_settings: ViewSettings;
    default_filters: any;
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/models/view-config/table-view-config.model.ts